var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tigan-wrap"},[_c('TiganTitle',{attrs:{"topic":_vm.topic,"index":_vm.index}}),_c('div',{staticClass:"tigan-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }